import React, { FC, RefObject, useEffect, useState } from 'react';
import { PollEllipsisMenuItem } from './poll-ellipsis-menu-item';
import {
  EllipsisMenu,
  LEFT_COORDINATS_SUM_PX,
  MOBILE_ELIPSIS_LEFT_CORRECTION,
  MOBILE_ELIPSIS_TOP_CORRECTION,
  MOBILE_ELIPSIS_TOP_CORRECTION_MOBILE,
  PollsTabsOnMobile,
  PollsViewStatuses
} from '../../../constans/polls-constants';
import pencilIcon from '../../../assets/icons/pencil.svg';
import closeIcon from '../../../assets/icons/close-icon.svg';
import pollIcon from '../../../assets/icons/polls-bar.svg';
import circleArrowIcon from '../../../assets/icons/circle-arrow.svg';
import './poll-ellipsis-menu.scss';
import { getMixpanelService } from '../../../utils/services/mixpanel-service-instance';
import { MIXPANEL_EVENT_IDENTIFIERS, MIXPANEL_EVENT_TYPES } from '../../../constans/mixpanel-contants';

interface IProps {
  setShouldShowEllipsisMenu: (value: boolean) => void;
  setShouldShowDeleteModal: (value: boolean) => void;
  setShouldShowResetModal: (value: boolean) => void;
  reopenPollHandler: () => void;
  toggleManagePollModal: () => void;
  forwardedRef: RefObject<HTMLButtonElement>;
  pollStatus: PollsViewStatuses;
  isClosingStatus: boolean;
  setActiveMobileTab: (tab: PollsTabsOnMobile) => void;
  isMobile: boolean;
  isOnePollOpened: boolean;
}

const getClientRectCoordinates = (current: HTMLButtonElement | null, isMobile: boolean): Pick<DOMRect, 'left' | 'top'> => {
  const NEGATIVE = -1;
  const clientRect = current?.getBoundingClientRect();
  const topCorrection = isMobile ? MOBILE_ELIPSIS_TOP_CORRECTION_MOBILE * NEGATIVE : MOBILE_ELIPSIS_TOP_CORRECTION;
  const left = isMobile && clientRect ? clientRect?.left - MOBILE_ELIPSIS_LEFT_CORRECTION : clientRect?.left;
  const top = isMobile && clientRect ? clientRect?.top + topCorrection : clientRect?.top;

  return {
    left: left || 0,
    top: top || 0
  };
};

const PollEllipsisMenu: FC<IProps> = ({
  setShouldShowEllipsisMenu,
  toggleManagePollModal,
  reopenPollHandler,
  forwardedRef,
  setShouldShowDeleteModal,
  setShouldShowResetModal,
  setActiveMobileTab,
  pollStatus,
  isClosingStatus,
  isMobile,
  isOnePollOpened
}) => {
  const initialCoordinates = getClientRectCoordinates(forwardedRef.current, isMobile);
  const [leftCoordinates, setLeftCoordinates] = useState<number>(initialCoordinates.left + LEFT_COORDINATS_SUM_PX);
  const [topCoordinates, setTopCoordinates] = useState<number>(initialCoordinates.top);

  const editActionHandler = () => {
    toggleManagePollModal();
    setShouldShowEllipsisMenu(false);
    setActiveMobileTab(PollsTabsOnMobile.DETAILS);
    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.POLLS, MIXPANEL_EVENT_TYPES.EDITED);
  };

  const deleteActionHandler = (): void => {
    setShouldShowDeleteModal(true);
  };

  const resetActionHandler = (): void => {
    setShouldShowResetModal(true);
  };

  const reopenPollActionHandler = (): void => {
    reopenPollHandler();
    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.POLLS, MIXPANEL_EVENT_TYPES.REOPENED);
  };

  const setCoordinates = (): void => {
    const cooridnates = getClientRectCoordinates(forwardedRef.current, isMobile);

    setLeftCoordinates(cooridnates.left + LEFT_COORDINATS_SUM_PX);
    setTopCoordinates(cooridnates.top);
  };

  const isCompletedStatus = (): boolean => {
    return pollStatus === PollsViewStatuses.COMPLETED && !isClosingStatus;
  };

  const isInProgressStatus = (): boolean => {
    return pollStatus === PollsViewStatuses.IN_PROGRESS || isClosingStatus;
  };

  const isReopenDisabled = (): boolean => {
    return !isCompletedStatus() || isOnePollOpened;
  };

  const menuItemsProps = [
    { isDisabled: isReopenDisabled(), text: EllipsisMenu.REOPEN, icon: pollIcon, actionHandler: reopenPollActionHandler },
    { isDisabled: isInProgressStatus(), text: EllipsisMenu.EDIT, icon: pencilIcon, actionHandler: editActionHandler },
    { isDisabled: !isCompletedStatus(), text: EllipsisMenu.RESET, icon: circleArrowIcon, actionHandler: resetActionHandler },
    { isDisabled: isInProgressStatus(), text: EllipsisMenu.DELETE, icon: closeIcon, actionHandler: deleteActionHandler },
  ];

  //Should use resize listener + fix position for menu, cos list have overflow for y axis
  useEffect(() => {
    window.addEventListener('resize', setCoordinates);

    return () => {
      window.removeEventListener('resize', setCoordinates);
    };
  }, []);


  return (
    <div className='poll-ellipsis-menu' style={{ left: leftCoordinates, top: topCoordinates }}>
      {menuItemsProps.map((el) => {
        return (
          <PollEllipsisMenuItem
            key={el.text}
            isDisabled={el.isDisabled}
            text={el.text}
            icon={el.icon}
            actionHandler={el.actionHandler}
            setShouldShowEllipsisMenu={setShouldShowEllipsisMenu}
          />
        );
      })
      }
    </div>
  );
};

export default PollEllipsisMenu;
